export default __webpack_public_path__ + "static/media/QSGA_Cells_Funcs01.70111a89.png";